import { supabase } from '@/lib/supabaseClient';
import { FarmRecord } from '@/types/database';

/**
 * Service for querying active farms from master data.
 */
export const farmService = {
  /**
   * Fetches all active farms from the database.
   */
  async getActiveFarms(): Promise<FarmRecord[]> {
    const { data, error } = await supabase
      .from('farms')
      .select('id, farm_name, barangay, municipality_city, province, is_active')
      .eq('is_void', false)
      .order('farm_name', { ascending: true });

    if (error) {
      console.warn('[farmService] Could not fetch farms from master table:', error.message);
      return [];
    }

    return (data || []).map((f) => ({
      id: f.id,
      farm_name: f.farm_name,
      barangay: f.barangay,
      municipality_city: f.municipality_city,
      province: f.province,
      is_active: f.is_active ?? true,
    }));
  },
};
